<h2 mat-dialog-title>Удалить бронирование?</h2>
<mat-dialog-content>
  <div class="warn-icon-wrap">
    <mat-icon color="warn" class="warn-icon">warning</mat-icon>
  </div>
  <p class="warn-text">Это действие нельзя отменить.</p>
  <div class="booking-meta">
    <div class="booking-meta-row">
      <span>Автомобиль:</span>
      <strong>{{ data.booking.car_title }}</strong>
    </div>
    <div class="booking-meta-row" *ngIf="data.booking.license_plate">
      <span>Госномер:</span>
      <strong>{{ data.booking.license_plate }}</strong>
    </div>
    <div class="booking-meta-row">
      <span>Клиент:</span>
      <strong>{{ data.booking.client_name }}</strong>
    </div>
    <div class="booking-meta-row">
      <span>Период:</span>
      <strong>{{ data.booking.start_date | date:'medium' }} — {{ data.booking.end_date | date:'medium' }}</strong>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Отмена</button>
  <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Удалить</button>
</mat-dialog-actions>
